export default "__VITE_ASSET__Cafa9uyX__"